import Vue                  from 'vue';
import VueRouter            from 'vue-router';
import Store                from '../store/index.js';

import VisitorLayout        from '../views/visitor/Layout.vue';
import Login                from '../components/Login.vue';
import Signup               from '../components/Signup.vue';
import ForgotPassword       from '../components/ForgotPassword.vue';
import ResetPassword        from '../components/ResetPassword.vue';


import DashboardLayout      from '../views/dashboard/Layout.vue';


import DealerUsers          from '../views/dashboard/tenants/DealerUsers.vue';

import ManufacturerEdit     from '../views/dashboard/admins/ManufacturerEdit.vue';
import DealerSearch         from '../views/dashboard/admins/DealerSearch.vue';
import AdminUsers           from "../views/dashboard/admins/AdminUsers.vue";
import AdminAlertMessage    from "../views/dashboard/admins/AdminAlertMessage2.vue";

import DealerProfile        from '../views/dashboard/tenants/DealerProfile.vue';
import Settings             from '../views/dashboard/tenants/Settings.vue';
import OrderSearch          from '../views/dashboard/tenants/OrderSearch.vue';
import OrderVersions        from '../views/dashboard/tenants/OrderVersions.vue';
import ManufacturerSearch   from '../views/dashboard/tenants/ManufacturerSearch.vue';
import CustomerSearch       from '../views/dashboard/tenants/CustomerSearch.vue';
import CoworkerSearch       from '../views/dashboard/tenants/CoworkerSearch.vue';
import ProductSearch        from '../views/dashboard/tenants/ProductSearch.vue';
import SalesRepProfile      from '../views/dashboard/tenants/SalesRepProfile.vue';
import CustomerOrder        from '../views/dashboard/tenants/CustomerOrder.vue';

import { userRoleEnum, getKeyByValue } from "../modules/helpers";

Vue.use(VueRouter);

const ensureAuthenticated = (to, from, next) => {
  // attempt to get token from local storage
  let savedToken = localStorage.getItem('token');
  if (savedToken){
    Store.dispatch('SET_TOKEN', JSON.parse(savedToken)).then(() => {
        
        next();
    }).catch(err => {
      // Store.dispatch('ADD_NOTIFICATION', { text: "You were logged off because your account is being used elsewhere", type: 'error' });
      Store.dispatch('AUTH_LOGOUT');
    });
    return;
  }
  if (Store.state.token) {
    Store.dispatch('GET_CURRENT_USER').then(res => {
      next();
    }).catch(err => {
      // Store.dispatch('ADD_NOTIFICATION', { text: "You were logged off because your account is being used elsewhere", type: 'error' });
        Store.dispatch('AUTH_LOGOUT');
    })
  } else {
    // Store.dispatch('ADD_NOTIFICATION', { text: "You were logged off because your account is being used elsewhere", type: 'error' });
    Store.dispatch('AUTH_LOGOUT');
  }
}

const ensureAuthorizeToEditDealerUsers = (to, from, next) => {
    let currentUserRole = getKeyByValue(userRoleEnum, Store.state.currentUser.UserRoleId);
    if (currentUserRole === 'SmartSales Admin') {
        next();
        return;
    }

    let currentUserDealerId = Store.state.currentUser.DealerId;
    let routeDealerId       = to.params.id;

    if (currentUserDealerId === routeDealerId){
        next();
    } else {
        next({ name: 'DashboardHome' }); // disallow
    }
}

const ensureAuthorizeToEditAdminUsers = (to, from, next) => {
    let currentUserRole = getKeyByValue(userRoleEnum, Store.state.currentUser.UserRoleId);
    if (currentUserRole === 'SmartSales Admin') {
        next();
    } else {
        next({ name: 'DashboardHome' }); // disallow
    }
}

const ensureAuthorizedSalesAdminOrAbove = (to, from, next) => {
    let currentUserRole = getKeyByValue(userRoleEnum, Store.state.currentUser.UserRoleId);
    if (['SmartSales Admin', 'Sales Administrator'].includes(currentUserRole)) {
        next();
    } else {
        next({ name: 'DashboardHome' }); // disallow
    }
}

const routes = [
  
  {
    path: '/',
    name: 'VisitorHome',
    component: VisitorLayout,
    redirect: { name: 'Login' },
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login,
      },
      {
        path: 'signup',
        name: 'Signup',
        component: Signup,
      },
      {
        path: 'forgot',
        name: 'ForgotPassword',
        component: ForgotPassword,
      },
      {
        path: 'reset',
        name: 'ResetPassword',
        component: ResetPassword,
      }
    ],
  },
  {
    path: '/dashboard',
    name: 'DashboardHome',
    component: DashboardLayout,
    redirect: { name: 'OrderSearch' },
    beforeEnter: ensureAuthenticated,

    children: [
        {
          path: 'order-search',
          name: 'OrderSearch',
          component: OrderSearch
        },
        {
          path: 'order-versions/:id',
          name: 'OrderVersions',
          component: OrderVersions,
          beforeEnter: ensureAuthorizedSalesAdminOrAbove
        },
        {
          path: 'customer-order/:cid?',
          name: 'CustomerOrder',
          component: CustomerOrder,
        },
        {
          path: 'customer-order/:cid?/:id/edit',
          name: 'CustomerOrderEdit',
          component: CustomerOrder,
        },
        {
          path: 'settings',
          name: 'Settings',
          component: Settings,
        },
        {
          path: 'profile/:id',
          name: 'DealerProfile',
          component: DealerProfile,
        },
        {
          path: 'dealers',
          name: 'DealerSearch',
          component: DealerSearch,
        },
        {
          path: 'dealers/:id/users',
          name: 'DealerUsers',
          component: DealerUsers,
          beforeEnter: ensureAuthorizeToEditDealerUsers,
        },
        {
          path: 'users',
          name: 'AdminUsers',
          component: AdminUsers,
          beforeEnter: ensureAuthorizeToEditAdminUsers,
        },
        {
          path: 'alert-message',
          name: 'AdminAlertMessage',
          component: AdminAlertMessage,
          beforeEnter: ensureAuthorizeToEditAdminUsers,
        },
        {
          path: 'manufacturers',
          name: 'ManufacturerSearch',
          component: ManufacturerSearch
        },
        {
          path: 'manufacturers/:id/edit',
          name: 'ManufacturerEdit',
          component: ManufacturerEdit,
        },
        {
          path: 'smart-catalog-manufacturers/:id/edit',
          name: 'SmartCatalogManufacturerEdit',
          component: ManufacturerEdit,
        },
        {
          path: 'customer-search',
          name: 'CustomerSearch',
          component: CustomerSearch
        },
        {
          path: 'colleague-search',
          name: 'CoworkerSearch',
          component: CoworkerSearch
        },
        {
          path: 'product-search',
          name: 'ProductSearch',
          component: ProductSearch
        },
        {
          path: 'my-profile',
          name: 'SalesRepProfile',
          component: SalesRepProfile
        },
    ]
  },
  {
    path: '*',
    redirect: { name: 'DashboardHome' },
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Refresh banner when navigating between different routes
// This ensures users see new banners without needing to manually refresh
router.afterEach((to, from) => {
  // Skip on initial page load (from.name is undefined)
  if (from.name && to.name !== from.name) {
    Store.dispatch('GET_ALERT_MESSAGE');
  }
});

export default router
